// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/menu/menu-item/menu-item.component.scss
// module id = 216
// module chunks = 0